/**
 * @generated SignedSource<<36d90fc28139d4ed7ad9683adb26c9af>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type certificateEmitDialogMutation$variables = {
  course: string;
  name: string;
};
export type certificateEmitDialogMutation$data = {
  readonly certificateEmit: {
    readonly file: {
      readonly signedUrl: string;
    };
    readonly id: string;
  };
};
export type certificateEmitDialogMutation = {
  response: certificateEmitDialogMutation$data;
  variables: certificateEmitDialogMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "course"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "name"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "course",
    "variableName": "course"
  },
  {
    "kind": "Variable",
    "name": "name",
    "variableName": "name"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "signedUrl",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "certificateEmitDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Certificate",
        "kind": "LinkedField",
        "name": "certificateEmit",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ObjectFile",
            "kind": "LinkedField",
            "name": "file",
            "plural": false,
            "selections": [
              (v3/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "certificateEmitDialogMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "Certificate",
        "kind": "LinkedField",
        "name": "certificateEmit",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "ObjectFile",
            "kind": "LinkedField",
            "name": "file",
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v2/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "56ad1b792367d114de6a371d3db1d033",
    "id": null,
    "metadata": {},
    "name": "certificateEmitDialogMutation",
    "operationKind": "mutation",
    "text": "mutation certificateEmitDialogMutation(\n  $course: ID!\n  $name: String!\n) {\n  certificateEmit(course: $course, name: $name) {\n    id\n    file {\n      signedUrl\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "9e77a17911af32d46a627ef391ed786e";

export default node;
